import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class EncryptionAccessLogMapEntity extends Entity {
    constructor() {
        super(...arguments);
        this.cityName = '';
        this.countryName = '';
        this.encryptionAccessLogId = '';
        this.encryptionId = '';
        this.email = '';
        this.eventType = '';
        this.latitude = 0;
        this.longitude = 0;
        this.statusDetails = '';
        this.territoryName = '';
        this.creationDTTM = new Date(0);
    }
    pk() {
        return btoa(JSON.stringify(this));
    }
}
EncryptionAccessLogMapEntity.schema = {
    creationDTTM: ISODate
};
EncryptionAccessLogMapEntity.key = 'EncryptionAccessLogMap';
export { EncryptionAccessLogMapEntity };
